import { A9Service } from 'components/system/angular';
import { AbstractDataProviderV2, ActionTypes } from 'components/system/data-provider';
import { CustomerUpdateEhcp } from 'common/customers/services/types/CustomerUpdateEhcp';

@A9Service('customerEditEhcpDataProvider')
export class CustomerEditEhcpDataProvider extends AbstractDataProviderV2<{}, {}, {}, CustomerUpdateEhcp> {
    constructor() {
        super();
        this.setApiUrl('middle://rs/customers/{customerId}/ehcp');
    }

    public update(item: object, resourceParams: any = {}): Promise<any> {
        return this.service.updateRequest<any>(`middle://rs/customers/${resourceParams.customerId}/ehcp`, 'PUT', item).then(() => {
            this.notify({ type: ActionTypes.Update, hash: `middle://rs/customers/${resourceParams.customerId}/golf` }, false);
            this.notify({ type: ActionTypes.Update, hash: `middle://rs/customers/${resourceParams.customerId}/stat/dash` }, false);
        });
    }

    public list() {
        return Promise.reject('Method `list` is not available');
    }

    public get() {
        return Promise.reject('Method `get` is not available');
    }

    public add() {
        return Promise.reject('Method `add` is not available');
    }

    public patch() {
        return Promise.reject('Method `patch` is not available');
    }

    public remove() {
        return Promise.reject('Method `remove` is not available');
    }
}
